import { format } from 'date-fns';

export const formatDateToMoveFile = (date?: string) =>
  date ? format(new Date(date), 'yyyy-MM-dd') : '';
